module.exports = __webpack_public_path__ + "img/ico_fh.ab93e0a3.svg";